import React, { useContext, ReactElement, CSSProperties, JSX } from "react";
import { Container, Row, Col, Modal, Button } from "react-bootstrap";
//import { LocalisationContext } from "../../store/LocalisationContext";
interface SXModalBaseProps {
  header: string | JSX.Element;

  show?: boolean;
  size?: "sm" | "lg" | "xl";

  close?: () => void;
  style?: CSSProperties;

  body: ReactElement | null;
  bodyStyle?: CSSProperties;

  footer: ReactElement | null;
  className?: string;
}
enum Lang {
  en = "en",
}

export const SXModalBase = (props: SXModalBaseProps) => {
  return (
    <>
      <Modal
        className={`sxmodal ${props.className ?? ""}`}
        size={props.size}
        show={props.show}
        onHide={props.close}
        style={props.style}
      >
        <Container id="sx-table-container">
          <Row className="table-header align-items-center">
            <Col className="text-center table-header-bg">
              <Modal.Header closeButton={!!props.close}>
                <Modal.Title className="headerModal">{props.header}</Modal.Title>
              </Modal.Header>
            </Col>
          </Row>
        </Container>

        <Modal.Body style={props.bodyStyle}>{props.body}</Modal.Body>

        <Modal.Footer className="sxmodal-footer">{props.footer}</Modal.Footer>
      </Modal>
    </>
  );
};

/* props.close (not .onClose) */
export const SXModalButtonCancel = (props: { lang: Lang; close: (reason: number) => void }) => {
  let userLang: Lang = Lang.en;
  userLang = props.lang;

  return (
    <Button
      id="modal_button_cancel"
      data-testid="modal_footer_button_cancel"
      // style={{ zIndex: 9999999 }}
      className="modal-btn"
      onClick={(e) => {
        props.close(-1);
      }}
    >
      cancel_
    </Button>
  );
};
